import { fieldFallbackLabel } from "@smart/bridge-intake-components-dom";
import { ProgressBar } from "@smart/itops-sb-design-system-dom";

import { PendingField } from "../types";

type PendingFieldCardProps = {
  field: Pick<PendingField, "type" | "label">;
};

export const PendingSignatureCard = ({ field }: PendingFieldCardProps) => (
  <div
    aria-disabled
    aria-busy
    data-testid="pending-signature-card"
    className="relative overflow-hidden pointer-events-none border-2 border-dashed border-neutral-200 rounded w-full max-w-screen-readable mx-auto bg-white p-[0.4rem] mb-[0.8rem]"
  >
    <div className="flex flex-col gap-small p-[1rem] pb-[1.5rem]">
      <span className="font-semibold text-ui text-neutral-850">
        {field.label || fieldFallbackLabel.signature}
      </span>
      <p className="text-neutral-500 text-caption m-0">
        Checking digital signature setup for your firm
      </p>
    </div>
    <ProgressBar overlay className="h-[0.2rem]" />
  </div>
);

export const PendingFieldCard = ({ field }: PendingFieldCardProps) => {
  switch (field.type) {
    case "signature":
      return <PendingSignatureCard field={field} />;
    default:
      return null;
  }
};
